import { render, staticRenderFns } from "./CaTooltipJira.vue?vue&type=template&id=91f075f4"
import script from "./CaTooltipJira.vue?vue&type=script&lang=ts"
export * from "./CaTooltipJira.vue?vue&type=script&lang=ts"
import style0 from "./CaTooltipJira.vue?vue&type=style&index=0&id=91f075f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
